import * as mock from "../mocks/sims.mock.js";

export function listSims() {
  return mock.listSims();
}

export function createSim(payload) {
  return mock.createSim(payload);
}

export function updateSim(simId, payload) {
  return mock.updateSim(simId, payload);
}

export function deleteSim(simId) {
  return mock.deleteSim(simId);
}

export { SIM_STATUSES, formatSimTimestamp } from "../mocks/sims.mock.js";
